export const REQUEST_SENT_ACTION_FETCH  = 'request_sent_action_fetch'
export const FETCH_SENT_ACTION_SUCCESS = 'fetch_sent_action_success'
export const FETCH_SENT_ACTION_FAILURE = 'fetch_sent_action_failure'
export const NEW_MESSAGE_ADDED = 'new_message_added'

export const CLEAR_FETCH_SENT_ACTION_STATES = 'clear_fetch_sent_action_states'